import { render, staticRenderFns } from "./ClockRecordsTab.vue?vue&type=template&id=5e0961f1&scoped=true"
import script from "./ClockRecordsTab.vue?vue&type=script&lang=js"
export * from "./ClockRecordsTab.vue?vue&type=script&lang=js"
import style0 from "./ClockRecordsTab.vue?vue&type=style&index=0&id=5e0961f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0961f1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabItem,VTabs,VTabsItems})
